export default [
  { text: 'By Name ↓', params: ['name', 'ASC'], value: 0 },
  { text: 'By Name ↑', params: ['name', 'DESC'], value: 1 },
];
